<template>
  <div class="h-100">
    <v-loader v-if="loadingTravelBook" />
    <div class="container mt-32">
      <div class="row">
        <!-- Logo and Company Info -->
        <div class="col-md-6">
          <div class="logo">
            <img src="https://waw.travel/wp-content/uploads/2019/12/WAW-logolow.jpg" height="80" />
          </div>
          <div class="client-info">
            <p>
              <strong>{{ $t("invoiceTour.client") }}:</strong> {{ invoiceBankDetail?.client_name }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.name") }}:</strong> {{ invoiceBankDetail?.case_name }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.quote") }}:</strong> Q1555
            </p>
          </div>
        </div>
        <!-- Invoice Details -->
        <div class="col-md-6 text-end">
          <div class="invoice-header">
            <strong>WAW Travel Adventures SL</strong><br />
            <strong>VAT: ESB75477679</strong> <br />
            <strong>ILiada Street, 15</strong> <br />
            <strong>24191 SAN ANDRES DEL RABANEDO (LEÓN)</strong><br />
            <strong>SPAIN</strong>
            <br />
            <br />
            <strong>{{ $t("invoiceTour.invoice") }}</strong
            >: {{ invoiceData?.number }}
            <br />
            <strong>{{ $t("invoiceTour.date") }}</strong
            >: 18/01/2025
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mb-16">
        <v-button class="btn-primary" @click="downloadInvoice" :disabled="downloadingPdf">
          <v-icon icon="download" /> {{ $t("invoiceTour.download_invoice") }}
        </v-button>

        <v-button class="btn-primary ms-8" @click="sendEmail">
          <v-icon icon="mail" /> {{ $t("invoiceTour.send_notification") }}
        </v-button>
      </div>

      <!-- Trip Details Box -->
      <div class="trip-details">
        <h5>{{ invoiceBankDetail?.tour_name }}</h5>
        <br />
        <div class="row">
          <div class="col-md-6">
            <p>
              <strong>{{ $t("invoiceTour.trip_details.case_name") }}:</strong> {{ invoiceBankDetail?.case_name }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.trip_details.destination") }}:</strong> {{ invoiceBankDetail?.destination }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.trip_details.accommodation") }}:</strong> HOTELS
            </p>
            <p>
              <strong>{{ $t("invoiceTour.trip_details.transfer") }}:</strong> {{ invoiceBankDetail?.has_transfer }}
            </p>
          </div>
          <div class="col-md-6">
            <p>
              <strong>{{ $t("invoiceTour.trip_details.ebike") }}:</strong> {{ invoiceBankDetail?.has_bike }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.trip_details.luggage_transfer") }}:</strong>
              {{ invoiceBankDetail?.has_luggage }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.pax") }}:</strong> {{ invoiceBankDetail?.pax }}
            </p>
            <p>
              <strong>{{ $t("invoiceTour.trip_details.date") }}:</strong>
              {{ $str.formatDateTime(invoiceBankDetail?.date_from, settings.formatDate) }} -
              {{ $str.formatDateTime(invoiceBankDetail?.date_to, settings.formatDate) }}
            </p>
          </div>
        </div>
      </div>

      <!-- Trip Programme -->
      <div class="trip-programme">
        <h5 class="section-title">{{ $t("invoiceTour.trip_programme") }}</h5>
        <table class="table mb-0">
          <tbody>
            <tr v-if="invoiceData.invoice_lines">
              <td>{{ invoiceData.invoice_lines[0].description }}</td>
              <td class="text-end">{{ `€ ${invoiceData.invoice_lines[0].amount}` }}</td>
            </tr>
            <tr>
              <td>{{ $t("invoiceTour.pax") }}</td>
              <td class="text-end">{{ invoiceBankDetail?.pax }}</td>
            </tr>
            <tr>
              <td class="w-85">{{ $t("invoiceTour.total_program") }}</td>
              <td class="text-end w-15">{{ `€ ${invoiceBankDetail?.tour_total_price}` }}</td>
            </tr>
            <!-- <tr>
                <td>Deposit 30%</td>
                <td class="text-end">€ 714,00</td>
              </tr> -->
            <!-- <tr>
                <td><em>Rest to be paid before 07/05/25</em></td>
                <td class="text-end">€ 1.666,00</td>
              </tr> -->
          </tbody>
        </table>
      </div>

      <div class="total-deposit">
        <div class="row">
          <div class="col-6">
            <strong>{{ $t("invoiceTour.total_deposit") }}</strong>
          </div>
          <div class="col-6 text-end">
            <strong> {{ `€ ${invoiceData?.amount}` }}</strong>
          </div>
        </div>
      </div>

      <!-- Payment Details -->
      <div class="payment-details">
        <h5>{{ $t("invoiceTour.payment_method") }}</h5>
        <table class="table">
          <tbody>
            <tr>
              <th colspan="2">{{ $t("invoiceTour.bank_transfer") }}</th>
              <td></td>
            </tr>
            <tr>
              <th>{{ $t("invoiceTour.bank_name") }}</th>
              <td>WAW TRAVEL ADVENTURES SL</td>
            </tr>
            <tr>
              <th>{{ $t("invoiceTour.iban") }}</th>
              <td>BE49 9051 6610 9271</td>
            </tr>
            <tr>
              <th>{{ $t("invoiceTour.swift_bic") }}</th>
              <td>TRWIBEB1XXX</td>
            </tr>
            <tr>
              <th>{{ $t("invoiceTour.bank_name") }}</th>
              <td>WISE</td>
            </tr>
            <tr>
              <th>{{ $t("invoiceTour.address") }}</th>
              <td>Rue du Trône 100, 3rd floor, Brussels, 1050, Belgium</td>
            </tr>
            <tr>
              <th>{{ $t("invoiceTour.concept") }}</th>
              <td>INVOICE 25/060</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="TheCaseInvoicePdf">
import { ref, computed, onMounted } from "vue";
import api from "@/api";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import { useAppStore } from "@/stores/app";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

const props = defineProps({
  caseId: {
    type: String,
    required: true,
  },
  invoice: {
    type: String,
    required: true,
  },
});

const invoiceData = ref<Record<string, any>>({});
const invoiceBankDetail = ref<Record<string, any>>({});
const loadingTravelBook = ref<boolean>(true);
const downloadingPdf = ref<boolean>(false);

const appStore = useAppStore();
const route = useRoute();
const toast = useToast();
const settings = computed(() => appStore.settings);

const agency = computed(() => {
  const a = route.query.agency;
  const v = Array.isArray(a) ? a[0] : (a as string | undefined);
  return v;
});

onMounted(async () => {
  try {
    const response = await api.invoice.showInvoice(
      agency.value,
      Number(props.caseId),
      Number(props.invoice),
    );

    if (response) {
      invoiceBankDetail.value = response.meta;
      invoiceData.value = response.content;
    }
  } catch (error) {
    console.error("Error loading invoice PDF:", error);
  } finally {
    loadingTravelBook.value = false;
  }
});

const sendEmail = async () => {
  const payload = {
    "pax_id": 2,
    "email": "sudipdahal509@gmail.com"
  };

  try {
    const response = await api.invoice.sendInvoiceEmail(
      agency.value,
      Number(props.caseId),
      Number(props.invoice),
      payload
    );

    if (response) {
      toast.success("Invoice email has been sent successfully");
    }
  } catch (error) {
    console.error("Error sending invoice email:", error);
    toast.error("Failed to send invoice email");
  }
};

const downloadInvoice = async () => {
  downloadingPdf.value = true;

  try {
    const response = await api.invoice.downloadCaseInvoice(
      agency.value,
      Number(props.caseId),
      Number(props.invoice),
    );

    const base64 = response?.pdf_base64;

    // --- Convert base64 → Blob ---
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // --- Trigger download ---
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoice-${props.invoice}.pdf`);
    document.body.appendChild(link);

    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.error("Error downloading invoice:", e);
  } finally {
    downloadingPdf.value = false;
  }
};

</script>

<style scoped>
.logo {
  width: 150px;
  height: 60px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.invoice-header {
  margin-bottom: 30px;
}
.trip-details,
.trip-programme {
  border: 1px solid #dee2e6;
  padding: 15px;
  margin-bottom: 20px;
}
.total-deposit {
  background-color: #f8d7da;
  padding: 10px;
}
.payment-details {
  margin-top: 30px;
}
.section-title {
  margin-bottom: 15px;
}
</style>
